import React, { useRef, useEffect } from "react";
import HomeHeader from "share/organisms/headers/landing-header";
import Container from "share/atoms/container/";
import { useHistory } from "react-router-dom";
import { useScroll } from "share/hooks";
import styled from "styled-components";
import Exams from "./Exams";
import Explore from "./Explore";
import WhyChooseUs from "./WhyChooseUs";
import AvailablePlatforms from "./AvailablePlatforms";
import ContactUs from "./ContactUs";
import Footer from "./Footer";
import HeroScreen from "share/organisms/hero";
import Legacy from "./Legacy";
import Stats from "school-admin/Landing/Stats";
import { useScrollTo } from "share/hooks/useScrollTo";
import { SchoolLandingLayout } from "school-admin/Landing/styles";
import AwardCeremony from "containers/award-ceremony";
import Login from "student/Login";
import { useWindowSize } from "share/hooks";
import { getIsDeviceRestricted } from "./helper";
import DeviceNotSupport from "./DeviceNotSupport";
import { isMobile } from "react-device-detect";

function LandingHome(props) {
  return isMobile ? (
    <DeviceNotSupport
      title="Heads up!"
      description="Please switch to a desktop device to continue."
    />
  ) : (
    <Login {...props} />
  );
}

export default LandingHome;
